import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import {Link} from 'react-router-dom';

import {
    setItems
} from '../../modules/cableTypes'

import {
    setCableType
} from '../../modules/order'

import RadioFormType from './../../components/RadioFormType';

class CableType extends React.Component {

    componentDidMount() {
        ReactDOM.findDOMNode(this).scrollIntoView();
    }

    onCableTypeChanged(value){
        this.props.setCableType({
            cable_type: value
        });
    }

    render()
    {
        return(
            <div className="content-container">
                <div className="content">
                    <div className="configurator_form">
                        <div className="row">
                            <h2>2.3 Cable Type</h2>
                            <p>Select the type of cable you want to use.</p>
                            {this.props.cableTypes.items.length > 0 &&
                            <RadioFormType items={this.props.cableTypes.items} input_name="cable_type"
                                           onTypeChanged={(value) => this.onCableTypeChanged(value)} checked={this.props.order.cable_type}/>
                            }
                        </div>
                        {this.props.order.cable_type !== null &&
                        <div>
                            <div className="hr"></div>
                            <div className="align-right">
                                <Link to="/CableLength" className="a_button"><button type="button">Next: Choose your cable length »</button></Link>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    config: state.config,
    cableTypes: state.cableTypes,
    order: state.order
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setItems,
    setCableType
}, dispatch)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CableType)


// WEBPACK FOOTER //
// ./../../htdocs/neutrik-opticalcon_fe/src/containers/CableType/index.js